import Vue from 'vue';
import Vuex, { Store } from 'vuex';

import common from './common';
import rbac from './rbac';

const debug = process.env.NODE_ENV !== 'production';

Vue.use(Vuex);

export default new Store({
  modules: {
    common,
    rbac,
  },
  strict: debug,
});



// WEBPACK FOOTER //
// ./src/store/index.js